import { useEffect, useRef } from 'react';

/**
 * Simple hook to scroll section into view when entering edit mode.
 */
export const useScrollToSectionOnEdit = (isEditing: boolean) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const wasEditingRef = useRef(false);

  useEffect(() => {
    if (isEditing && !wasEditingRef.current) {
      requestAnimationFrame(() => {
        sectionRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    }
    wasEditingRef.current = isEditing;
  }, [isEditing]);

  return sectionRef;
};
